import _ from 'lodash';

/**
 * Extraire les objets contenus dans l'objet source.
 * L'objet source est également retourné.
 *
 * @param {Object} object L'objet source.
 * @param {Function} predicate Fonction indiquant s'il faut extraire l'objet.
 * @param {Function} format Fonction formattant l'objet conservé dans l'objet source.
 * @returns {Array} Array des objets extraits incluant l'objet source.
 */

export default function extract(obj, predicate, format) {
  if (!obj) return obj;
  let array = [];

  function getValue(value, key, parent) {
    if (!_.isPlainObject(value)) return value;

    if (predicate(value, key, parent)) {
      array = array.concat(extract(value, predicate, format));
      return format ? format(value, key, parent) : value;
    }

    const res = extract(value, predicate, format);
    array = array.concat(_.tail(res));
    return res[0];
  }

  const formattedObj = _.mapValues(obj, (value, key) => {
    const fn = v => getValue(v, key, value);
    return _.isArray(value) ? value.map(fn) : fn(value);
  });

  return [formattedObj, ...array];
}
